export default __webpack_public_path__ + "static/media/offer-icon-banner.24550b17.svg";